module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/reception-advanced/reception-advanced.component.scss
// module id = ./src/app/modules/reception-advanced/reception-advanced.component.scss
// module chunks = main